import { createTheme } from "@mui/material/styles";
import { designTokens } from "../../theme/designTokens";

const padrao = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: designTokens.colors.primary.main,
			light: designTokens.colors.primary.light,
			dark: designTokens.colors.primary.dark,
			contrastText: designTokens.colors.primary.contrastText,
		},
		secondary: {
			main: designTokens.colors.secondary.main,
			light: designTokens.colors.secondary.light,
			dark: designTokens.colors.secondary.dark,
			contrastText: designTokens.colors.secondary.contrastText,
		},
		error: {
			main: designTokens.colors.error,
			contrastText: "#fff",
		},
		warning: {
			main: designTokens.colors.warning,
		},
		info: {
			main: designTokens.colors.info,
		},
		success: {
			main: designTokens.colors.success,
		},
		text: designTokens.colors.text,
		background: designTokens.colors.background,
	},
});

const appTema = createTheme({
	palette: {
		mode: "light",
		primary: { main: padrao.palette.primary.main },
		secondary: {
			main: padrao.palette.secondary.main,
			contrastText: "#fff",
		},
		error: { main: padrao.palette.error.main, contrastText: "#fff" },
		text: {
			// secondary : '#ffcc00'
		},
	},
	typography: {
		htmlFontSize: 16,
		h1: {
			fontSize: designTokens.typography.h1.fontSize,
			lineHeight: designTokens.typography.h1.lineHeight,
			fontWeight: designTokens.typography.h1.fontWeight,
		},
		h2: {
			fontSize: designTokens.typography.h2.fontSize,
			lineHeight: designTokens.typography.h2.lineHeight,
			fontWeight: designTokens.typography.h2.fontWeight,
		},
		h3: {
			fontSize: designTokens.typography.h3.fontSize,
			lineHeight: designTokens.typography.h3.lineHeight,
			fontWeight: designTokens.typography.h3.fontWeight,
		},
		h4: {
			fontSize: designTokens.typography.h4.fontSize,
			lineHeight: designTokens.typography.h4.lineHeight,
			fontWeight: designTokens.typography.h4.fontWeight,
		},
		h5: {
			fontSize: designTokens.typography.h5.fontSize,
			lineHeight: designTokens.typography.h5.lineHeight,
			fontWeight: designTokens.typography.h5.fontWeight,
		},
		h6: {
			fontSize: designTokens.typography.h6.fontSize,
			lineHeight: designTokens.typography.h6.lineHeight,
			fontWeight: designTokens.typography.h6.fontWeight,
		},
		body1: {
			fontSize: designTokens.typography.body1.fontSize,
			lineHeight: designTokens.typography.body1.lineHeight,
		},
		body2: {
			fontSize: designTokens.typography.body2.fontSize,
			lineHeight: designTokens.typography.body2.lineHeight,
		},
		caption: {
			fontSize: designTokens.typography.caption.fontSize,
			lineHeight: designTokens.typography.caption.lineHeight,
		},
	},
	components: {
		MuiSlider: {
			styleOverrides: {
				thumb: {
					color: padrao.palette.secondary.main,
					"&:hover": {
						color: designTokens.colors.hover,
					},
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				deleteIcon: {
					color: padrao.palette.secondary.main,
					"&:hover": {
						color: designTokens.colors.hover,
					},
				},
				icon: {
					color: padrao.palette.secondary.main,
					"&:hover": {
						color: designTokens.colors.hover,
					},
				},
			},
			defaultProps: { variant: "outlined" },
		},
		MuiButton: {
			styleOverrides: {
				root: {
					"&:hover": {
						color: "#fff",
						backgroundColor: designTokens.colors.hover,
					},
				},
				textPrimary: {
					color: padrao.palette.secondary.main,
					"&:hover": {
						color: designTokens.colors.hover,
						backgroundColor: "#fff",
					},
				},
				textSecondary: {
					backgroundColor: padrao.palette.secondary.main,
					color: "#fff",
					"&:hover": {
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
				containedSecondary: {
					"&:hover": {
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
				outlinedSecondary: {
					"&:hover": {
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						border: `1px solid ${designTokens.colors.hover}`,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
				colorInherit: {
					// Mui 4 não tem regra Error - o estilo foi aplicado no inherit
					//pois as unicas regras disponiveis são default'| 'inherit'| 'primary'| 'secondary'
					backgroundColor: padrao.palette.error.main,
					color: "#fff",
					"&:hover": {
						textDecoration: "none",
						backgroundColor: padrao.palette.error.dark,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: padrao.palette.error.dark,
						},
					},
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
					"& svg": {
						width: "0.9em",
						height: "0.9em",
						fontSize: "1.3rem",
					},
				},
				colorSecondary: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
					"&.Mui-checked:hover": {
						backgroundColor: `${designTokens.colors.hover} !important`,
					},
				},
			},
		},
		MuiListItem: {
			styleOverrides: {
				button: {
					"&:hover": {
						color: "#fff",
						backgroundColor: designTokens.colors.hover,
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
				root: {
					"&.Mui-selected, &.Mui-selected:hover": {
						backgroundColor: designTokens.colors.hover,
					},
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					color: "inherit",
					"&:hover": {
						color: "inherit",
						backgroundColor: "inherit",
					},
				},
			},
		},
		MuiCheckbox: {
			styleOverrides: {
				root: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
					"& svg": {
						width: "0.7em",
						height: "0.7em",
					},
				},
				colorSecondary: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
			},
		},
		MuiRadio: {
			styleOverrides: {
				root: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
					"& svg": {
						width: "0.7em",
						height: "0.7em",
					},
				},
				colorSecondary: {
					"&:hover": {
						color: "#fff",
						textDecoration: "none",
						backgroundColor: designTokens.colors.hover,
						// Reset on touch devices, it doesn't add specificity
						"@media (hover: none)": {
							backgroundColor: designTokens.colors.hover,
						},
					},
				},
			},
		},
		MuiListSubheader: {
			styleOverrides: {
				root: {
					fontSize: "1.25rem",
					"&.MuiListSubheader-sticky": {
						backgroundColor: designTokens.colors.background.paper,
					},
					"&.MuiListSubheader-sticky:hover": {
						color: designTokens.colors.primary.main,
					},
				},
			},
		},
		MuiLink: {
			styleOverrides: {
				underlineHover: {
					"&:hover": {
						color: designTokens.colors.hover,
					},
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: "1rem",
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					fontWeight: "bold",
				},
			},
		},
		MuiPaper: {
			defaultProps: { elevation: 3 },
			styleOverrides: {
				root: { padding: 16 }, // 16px = 2 * default spacing unit (more comfortable spacing)
			},
		},
		MuiGrid: {
			defaultProps: { spacing: 3 },
		},
		MuiLinearProgress: {
			defaultProps: { color: "secondary" },
		},
	},
});

export default appTema;
